module.exports = __webpack_public_path__ + "media/src/components/Footer/LicenseSection/irc-official-logo-1c0ed62e2bfbcea6e1ab5d38b14ca69d.png";